import React from 'react';
import { I18n } from '@fiverr-private/fiverr_context';
import classNames from 'classnames';
import { HALF_INDEX_SIZE, FULL_INDEX_SIZE } from '../../../utils/constants';
import { replaceUrlParam } from '../../../utils/url';

export const renderPageNumbers = (page, numberOfPages, offset, isTouch) => {
    const { startIndex, endIndex } = calculatePagesIndexes(page, numberOfPages);

    const pagesNum = endIndex - startIndex + 1;
    const pageNumbers = Array(...Array(pagesNum)).map((_, i) => (i + startIndex));

    if (isTouch) {
        return (
            <li className="is-touch-page-index"><I18n k="search_perseus.pagination.page"/> {page}</li>
        );
    }

    return pageNumbers.map((number) => {

        const pressed = classNames('page-number', isActivePage(page, number) ? 'active-page' : '');
        const url = pageUrl(number, offset);

        return (
            <li key={number}
                className={pressed}>
                {isActivePage(page, number) ? <span>{number}</span> : <a href={url}>{number}</a>}
            </li>
        );
    });
};

export const pageUrl = (pageNumber, offset) => {
    const url = replaceUrlParam('page', pageNumber);

    return offset ? replaceUrlParam('offset', offset, url) : url;
};

const calculatePagesIndexes = (page, numberOfPages) => {

    let startIndex = 1,
        endIndex = FULL_INDEX_SIZE;

    if (numberOfPages < FULL_INDEX_SIZE) {
        return { startIndex, endIndex: numberOfPages };
    }

    // End of the pagination
    if (page + HALF_INDEX_SIZE - 1 >= numberOfPages) {
        startIndex = numberOfPages - FULL_INDEX_SIZE + 1;
        endIndex = numberOfPages;
    }

    // Middle of the pagination
    else if (page - HALF_INDEX_SIZE > 1 && page + HALF_INDEX_SIZE - 1 < numberOfPages) {
        startIndex = page - HALF_INDEX_SIZE;
        endIndex = page + HALF_INDEX_SIZE - 1;
    }

    return { startIndex, endIndex };
};

const isActivePage = (page, number) => page === number;
